import React from 'react';
import { Form, Checkbox, Typography } from 'antd';

interface IQuoteTermsCheckboxProps {
    showTerms: boolean;
}

const QuoteTermsCheckbox: React.FC<IQuoteTermsCheckboxProps> = ({ showTerms }) => {
    if (!showTerms) return null;

    return (
        <Form.Item
            name="accepted_terms_conditions"
            valuePropName="checked"
            rules={[
                {
                    validator: (_, value) =>
                        value
                            ? Promise.resolve()
                            : Promise.reject(new Error('You must accept the terms and conditions to continue.')),
                },
            ]}
        >
            <Checkbox data-testid="terms-checkbox">
                I have read and accept the{' '}
                <Typography.Link
                    href="https://parts-badger.com/terms-and-conditions"
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={e => e.stopPropagation()}
                    style={{
                        textDecoration: 'underline',
                        fontWeight: 'bold',
                    }}
                    className="font-bold underline"
                >
                    terms and conditions
                </Typography.Link>
            </Checkbox>
        </Form.Item>
    );
};

export default QuoteTermsCheckbox;
